// Scopes of public API keys (/api/v1), shared by the server and the API keys section of the SPA.

export const API_SCOPES = ['forms:read', 'forms:write', 'sends:write', 'submissions:read'] as const;
export type ApiScope = (typeof API_SCOPES)[number];

export const SCOPE_DESCRIPTIONS: Record<ApiScope, string> = {
  'forms:read': 'List and read forms, inboxes, publish state and stats; validate definitions.',
  'forms:write': 'Create, update, duplicate, archive and publish forms.',
  'sends:write': 'Send published forms to conversations, contacts and phone numbers.',
  'submissions:read': 'List, read and export submissions.',
};

/** What a new key gets unless the administrator ticks more: read-only. */
export const DEFAULT_SCOPES: readonly ApiScope[] = ['forms:read', 'submissions:read'];
